<template>
    <div id="app">
        <router-view />
        <Modal />
        <bottombar/>
    </div>
</template>

<script>
import Modal from './components/Modal/Index.vue';
import Bottombar from "./components/Customers/Partials/Bottombar/Index.vue";
export default {
    name: 'App',
    components: {
        Modal,
        "bottombar": Bottombar,
    }
}
</script>
